import IconButton from '../../elements/icon-button'
import PropTypes from 'prop-types'

export default function NavButton({
  icon,
  onClick,
  disabled,
  className,
  ...props
}) {
  return (
    <div
      className={`tw-flex tw-flex-col tw-max-h-image-map tw-z-10 ${className}`}>
      <IconButton
        icon={icon}
        className="tw-text-xl tw-leading-none tw-w-12 tw-h-12 tw-border tw-border-solid tw-border-system-grey-200 tw-bg-white tw-rounded-md"
        disabled={disabled}
        onClick={onClick}
        {...props}
      />
    </div>
  )
}

NavButton.propTypes = {
  icon: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}
